import { LitElement, html } from './-global.min.js'

class HHCategories extends LitElement {
  constructor() {
    super()

    this.images = this.querySelectorAll('a.categories__item img')
  }

  connectedCallback() {
    super.connectedCallback()
    this.images.forEach((button) => {
      button.addEventListener('keyup', this.onKeyupImageHandler.bind(this))
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.images.forEach((button) => {
      button.removeEventListener('keyup', this.onKeyupImageHandler)
    })
  }

  onKeyupImageHandler(event) {
    if (event.type === 'keyup' && event.code.toUpperCase() !== 'ENTER') {
      return true
    }
    event && event.preventDefault()
    const href = event.target.closest('a').getAttribute('href') || ''
    if (href !== '' && href !== '#') {
      location.href = href
    }
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-categories', HHCategories)
